import Vue from 'vue';
import Vuex from 'vuex';
import {
  tokenService,
  accessLogService,
  personService,
  companyService,
  controllerService,
  zoneService,
} from '@/services';
import app from './modules/app';
import createUserModule from './modules/user';
import invitation from './modules/invitation';
import createAccessLogsModule from './modules/accessLogs';
import createPersonModule from './modules/person';
import createCompanyModule from './modules/company';
import createControllerModule from './modules/controller';
import createZoneModule from './modules/zone';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    user: createUserModule(tokenService),
    invitation,
    accessLogs: createAccessLogsModule(accessLogService),
    person: createPersonModule(personService),
    company: createCompanyModule(companyService),
    controller: createControllerModule(controllerService),
    zone: createZoneModule(zoneService),
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js